import * as React from "react"
import { ArticleCard } from "@/components/brand-kit/article-card"
import { SectionHeader } from "./section-header"
import type { BrandArticle } from "./types"

interface ArticlesGridProps {
  brandName: string
  articles: BrandArticle[]
}

/**
 * "{Brand} Articles" — the brand detail page's own article grid (handoff §6).
 *
 * FRIDGE-1086 (owner: "WHY MISSING BLOG STYLE? AUTHOR IMAGE, ETC … HOW MANY OTHER
 * PAGE TYPES ARE YOU MESSING THIS UP??"; docs/Design.md §22.6: every article
 * card, on every page type, is the one blog card style with the author's
 * photo). This grid used to be a bespoke card — no author photo, a "Buying
 * Guide" label no data backed, and a "N min read" figure hashed from the slug,
 * which is an invented number. It now renders the shared `ArticleCard`, the
 * same card the blog index, the hubs and the Related Articles strip use: hero
 * on a contained 16:9 letterbox, "Article" tag, title, the author's photo and
 * the date. An article without a hero gets the shared NoImageFallback mark
 * from inside ArticleCard (FRIDGE-239) — never a gradient.
 */
export function ArticlesGrid({ brandName, articles }: ArticlesGridProps) {
  if (articles.length === 0) return null
  return (
    <section className="my-12">
      <SectionHeader
        eyebrow="Read up"
        title={`${brandName} Articles`}
        description="Buying guides, comparisons, and how-tos with mentions of this brand."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {articles.slice(0, 6).map(a => (
          <ArticleCard
            key={a.id}
            href={`/blogs/news/${a.slug}`}
            imageUrl={a.image || undefined}
            badge="Article"
            title={a.title}
            author={a.author_name ?? undefined}
            authorImageUrl={a.authorImageUrl ?? null}
              excerpt={a.excerpt}
            date={a.published_at}
          />
        ))}
      </div>
    </section>
  )
}
